import { useState, useEffect } from "react";
import { Form, Col, Row } from "react-bootstrap";
import { CustomSelect, MaritalStatusOptions, SexOptions } from "../../../../../../_helpers/Helpers";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import KTImageInput from "../../../../../../_metronic/_assets/js/components/image-input";

export function PersonnelGeneralInfoForm({ 
  personnel,
  handleChange,
  setFieldValue,
  values
 }) {
  const [photo, setPhoto] = useState("");

  useEffect(() => {
    personnel.photoStr ? setPhoto(personnel.photoStr) : setPhoto("");
  }, [personnel]);

  const getPersonnelPhoto = () => {
    if (!photo) {
      return "none";
    }

    return `url(${photo})`;
  };

  const removePhoto = () => {
    setPhoto("");
  };

  new KTImageInput("personnel_photo");

  return (
    <>
      <div className="row">
        <div className="col-6">
          <Form.Group as={Row} controlId="photo">
            <Form.Label column sm={3}>
              Fotoğraf
            </Form.Label>
            <Col sm={9}>
              <div
                className="image-input image-input-outline"
                id="personnel_photo"
                style={{
                  backgroundImage: `url(${toAbsoluteUrl(
                    "/media/users/blank.png"
                  )}`,
                }}
              >
                <div
                  className="image-input-wrapper"
                  style={{ backgroundImage: `${getPersonnelPhoto()}`}}
                />
                <label
                  className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                  data-action="change"
                  data-toggle="tooltip"
                  title=""
                  data-original-title="Change photo"
                >
                  <i className="fa fa-pen icon-sm text-muted"></i>
                  <input
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    onChange={e => setFieldValue("photoFile", e.target.files[0])}
                  />
                  <input type="hidden" name="personnel_photo_remove" />
                </label>
                <span
                  onClick={e => setFieldValue("photoFile", null)}
                  className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                  data-action="cancel"
                  data-toggle="tooltip"
                  title=""
                  data-original-title="Cancel photo"
                >
                  <i className="ki ki-bold-close icon-xs text-muted"></i>
                </span>
                <span
                  onClick={removePhoto}
                  className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                  data-action="remove"
                  data-toggle="tooltip"
                  title=""
                  data-original-title="Remove photo"
                >
                  <i className="ki ki-bold-close icon-xs text-muted"></i>
                </span>
              </div>
              <span className="form-text text-muted">
                İzin Verilen Dosya Türleri: png, jpg, jpeg.
              </span>
            </Col>
          </Form.Group>
        </div>
      </div>

      <div className="row">
        <div className="col-6">  
          <Form.Group as={Row} controlId="personnelType">
            <Form.Label column sm={3}>
              Personel Türü<span> *</span>
            </Form.Label>
            <Col sm={9}>
              <CustomSelect 
                options={personnel.personnelTypes}
                value={values.personnelTypeId}
                onChange={option => handleChange("personnelTypeId")(option.value)}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="tcKimlikNo">
            <Form.Label column sm={3}>
              TC Kimlik No<span> *</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.tcKimlikNo} placeholder="TC Kimlik No" onChange={handleChange} />
            </Col>
          </Form.Group>
                    
          <Form.Group as={Row} controlId="name">
            <Form.Label column sm={3}>
              Adı<span> *</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.name} placeholder="Adı" onChange={handleChange} />
            </Col>
          </Form.Group>
                    
          <Form.Group as={Row} controlId="surname">
            <Form.Label column sm={3}>
              Soyadı<span> *</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.surname} placeholder="Soyadı" onChange={handleChange} />
            </Col>
          </Form.Group>
        </div>

        <div className="col-6">
          <Form.Group as={Row} controlId="birthPlace">
            <Form.Label column sm={3}>
              Doğum Yeri<span> *</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="input" value={values.birthPlace} placeholder="Doğum Yeri" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="birthDate">
            <Form.Label column sm={3}>
              Doğum Tarihi
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="date" value={values.birthDate} placeholder="Doğum Tarihi" onChange={handleChange} />
            </Col>
          </Form.Group>
                  
          <Form.Group as={Row} controlId="sex">
            <Form.Label column sm={3}>
              Cinsiyet
            </Form.Label>
            <Col sm={9}>
              <CustomSelect 
                options={SexOptions}
                value={values.sex}
                onChange={option => setFieldValue("sex", option.value)}
              />
            </Col>
          </Form.Group>
              
          <Form.Group as={Row} controlId="maritalStatus">
            <Form.Label column sm={3}>
              Medeni Hali
            </Form.Label>
            <Col sm={9}>
              <CustomSelect
                options={MaritalStatusOptions}
                value={values.maritalStatus}
                onChange={option => setFieldValue("maritalStatus", option.value)}
              />
            </Col>
          </Form.Group>
        </div>
      </div>
    </>
  );
}